import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentLinkService {
  private apiUrl = `${environment.apiUrl}/payment-links`;

  constructor(private http: HttpClient) { }

  /**
   * Obtiene la lista de payment links con paginación y filtros
   * @param params Parámetros de consulta (pageNumber, pageSize, isActive, dateFrom, dateTo, searchTerm, sortBy, sortDescending)
   * @returns Observable con la lista paginada de payment links
   */
  getPaymentLinks(params: any): Observable<any> {
    return this.http.get(this.apiUrl, { params });
  }

  /**
   * Obtiene el detalle de un payment link específico
   * @param id ID del payment link
   * @returns Observable con el detalle del payment link
   */
  getPaymentLinkById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }



  /**
   * Desactiva un link de pago específico por ID
   * @param paymentLinkId ID del payment link a desactivar
   * @returns Observable con el resultado de la operación
   */
  deactivatePaymentLink(paymentLinkId: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${paymentLinkId}`, { active: false });
  }

  /**
   * Desactiva un link de pago específico por WompiLinkId
   * @param wompiLinkId WompiLinkId del payment link a desactivar
   * @returns Observable con el resultado de la operación
   */
  deactivatePaymentLinkByWompiId(wompiLinkId: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/by-wompi/${wompiLinkId}`, {});
  }

  /**
   * Copia texto al portapapeles
   * @param text Texto a copiar
   * @returns Promise que indica si la operación fue exitosa
   */
  async copyToClipboard(text: string): Promise<boolean> {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Usar la API moderna del portapapeles
        await navigator.clipboard.writeText(text);
        return true;
      } else {
        // Fallback para navegadores más antiguos
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful;
      }
    } catch (error) {
      console.error('Error al copiar al portapapeles:', error);
      return false;
    }
  }
}
